module.exports = __webpack_public_path__ + "static/media/display-suite-12.15326b8b.jpg";